











import Vue from 'vue'
import Component from 'vue-class-component'
import { Watch } from 'vue-property-decorator'
import { State, Action } from 'vuex-class'

import TransactionHelperComponents1MainPage from './service-for-transaction-helper-components/transaction-helper-components-1-main-page.vue'
import App4PageNotFound from '../../../html-components-type-1-basic/basic-type-1-app/app-4-page-not-found.vue'

const namespace = 'digitalCurrency'

@Component({
  components: {
    TransactionHelperComponents1MainPage,
    App4PageNotFound
  }
})
class Transaction1 extends Vue {

  @State('serviceAccount') serviceAccount?: string

  @Action('getDigitalCurrencyTransactionById', { namespace }) getDigitalCurrencyTransactionById?: any

  transactionId: string = ''

  show404Message: boolean = false

  @Watch('serviceAccount') async updateServiceAccount (serviceAccount: any) {
    if (!serviceAccount) {
      return
    }
    await this.initializeTransaction()
  }

  @Watch('$route.params.transactionId') async updateRouteValue () {
    await this.initializeTransaction()
  }

  async mounted () {
    await this.initializeTransaction()
  }

  async initializeTransaction () {
    this.show404Message = false

    const transactionId = this.$router.currentRoute.params.transactionId

    const digitalCurrencyTransaction = await this.getDigitalCurrencyTransactionById(transactionId)

    if (!digitalCurrencyTransaction || !digitalCurrencyTransaction.transactionId) {
      this.show404Message = true
      return
    }

    this.transactionId = digitalCurrencyTransaction.transactionId
  }
}

export default Transaction1


